export default "__VITE_PUBLIC_ASSET__50a94020__"